import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
dayjs.extend(customParseFormat);
dayjs.extend(utc);
export const DEFAULT_DATE_FORMAT = 'MM/DD/YYYY';
export const NATIVE_FORMAT = 'YYYY-MM-DD';
export const toNativeDatePickerFormat = (date, dateFormat = DEFAULT_DATE_FORMAT) => {
    return dayjs(date, dateFormat, true).format(NATIVE_FORMAT);
};
export const formatDate = (date, dateFormat) => {
    return dayjs(date.toISOString()).utc().format(dateFormat);
};
//# sourceMappingURL=formatDate.js.map